
import React, { useRef } from 'react';
import ReactOwlCarousel from 'react-owl-carousel';
import { Link } from 'react-router-dom';
import { MdArrowRightAlt } from "react-icons/md";
import Img1 from '../../assets/images/collection/engagement-rings.png';
import Img2 from '../../assets/images/collection/wedding-rings.png';
import Img3 from '../../assets/images/collection/earrings.png';
import Img4 from '../../assets/images/collection/necklaces.png';
import Img5 from '../../assets/images/collection/bracelets.png';
import Img6 from '../../assets/images/collection/watches.png';
import { LuMoveRight, LuMoveLeft } from "react-icons/lu";
import { Col, Container, Row } from 'react-bootstrap';
import { isMobileOnly } from 'react-device-detect';
import Slider from 'react-slick';
import left from '../../../newyork/assets/images/left-arrow.png'
import right from '../../../newyork/assets/images/right-arrow.png'
import { tr } from 'date-fns/locale';


const data = [
    { id: 1, img: Img1, title: "Engagement Rings", link: '/jewelry/engagement-rings' },
    { id: 2, img: Img2, title: "Wedding Rings", link: '/jewelry/wedding-rings' },
    { id: 3, img: Img3, title: "Earrings", link: '/jewelry/earrings' },
    { id: 4, img: Img4, title: "Necklaces", link: '/jewelry/necklaces' },
    { id: 5, img: Img5, title: "Bracelets", link: '/jewelry/bracelets' },
    { id: 6, img: Img6, title: "Watches", link: '/watches' }
];


const mobileSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,

  prevArrow: <img src={left} className="img-fluid slick-prev-img" alt="left arrow" />,
  nextArrow: <img src={right} className="img-fluid slick-next-img" alt="right arrow" />,

  responsive: [
    {
      breakpoint: 768, // tablet
      settings: {
        slidesToShow: 1,
        dots: true,
         arrows: true,
      },
    },
    {
      breakpoint: 576, // mobile
      settings: {
        slidesToShow: 1,
        dots: true,
        autoplaySpeed: 1800,
         arrows: true,
      },
    },
    {
      breakpoint: 480, // small mobile
      settings: {
        slidesToShow: 1,
        dots: true,
        autoplaySpeed: 1500,
         arrows: true,
      },
    },
  ],
};

export const ExploreCollection = () => {
    const carouselRef = useRef(null);

    return (
        <>
            <section className='explore_collection white_box_collection'>
                <Container className='container-whitebox'>
                    <div className='title-box text-center mb-4'>
                        <h2>Explore Our Collection</h2>
                        <p>Find the Sparkle That Speaks to You</p>
                    </div>
                    <Row>
                        <Col>
                            {isMobileOnly ? (
                                <Slider {...mobileSettings} className="collection-slider">
                                    {data.map((item) => (
                                        <div key={item.id} className="collection-slide-item">
                                            <Link to={item.link} className="collection-card">
                                                <img src={item.img} alt={item.title} />
                                                <div className="collection-overlay">
                                                    <h4>{item.title}</h4>
                                                    <span className="shop-now">Shop Now</span>
                                                </div>
                                            </Link>
                                        </div>
                                    ))}
                                </Slider>
                            ) : (
                                /* DESKTOP VIEW — GRID */
                                <div className="collection-grid">
                                    {data.map((item) => (
                                        <Link to={item.link} className="collection-card" key={item.id}>
                                            <img src={item.img} alt={item.title} />
                                            <div className="collection-overlay">
                                                <h4>{item.title}</h4>
                                                <span className="shop-now">Shop Now</span>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            )}

                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};
